module.exports = "pegasus_template/assets/themecapture1/coming_soon/101.png";